// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAYOUT DES 2 CADRES */
.message_container {
    display: flex;
    gap: 32px;
    align-items: flex-start;
}

/* CADRES BLANCS */
.message_form,
.message_info {
    background: var(--white-principale);
    border-radius: 16px;
    padding: 24px;
    border: solid 1px var(--gris-secondaire);
    box-shadow:
        0 0 5px rgba(0, 0, 0, 0.05),
        0 0 10px rgba(0, 0, 0, 0.05),
        0 0 15px rgba(0, 0, 0, 0.08),
        0 0 20px rgba(0, 0, 0, 0.1);

}

.message_image_status {
    width: 20px;
    height: 20px;
    border: solid 2px var(--white-principale);
    border-radius: 50%;
    background-color: green;
    position: absolute;
    bottom: 10px;
    right: 5px;
}

.message_nom {
    font-size: 20px;
    font-weight: 700;
    color: var(--couleur-dark);
}

.message_status,
.message_tel {
    font-size: 13px;
    color: var(--couleur-dark);
}

/* LARGEURS */
.message_form {
    flex: 2 1;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.message_info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 32px;
}

/* HEADER MESSAGE */
.message_header {
    display: flex;
    justify-content: space-between;
}

.message_header_vendeur {
    display: flex;
}

.message_info_vendeur {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.message_image_vendeur {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 16px;
}

.message_logo_whatshapp {
    width: 30px;
    height: 30px;
}

/* BODY MESSAGE */
.message_body {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.message_body h1 {
    font-size: 18px;
    font-weight: 500;
    color: var(--couleur-dark);
}

.message_body h3 {
    font-size: 16px;
    font-weight: 400;
    color: var(--couleur-dark);
}

/* TEXTAREA */
.message_body textarea {
    width: 100%;
    min-height: 140px;
    resize: vertical;
    padding: 12px;
    font-size: 14px;
    border-radius: 8px;
    border: 1px solid var(--gris-secondaire);
}

/* BOUTON */
.message_form button {
    align-self: flex-start;
    width: 100%;
    padding: 10px 24px;
    border-radius: 10px;
    border: none;
    font-size: 16px;
    background: var(--couleur-principale);
    color: var(--white-principale);
    font-weight: 700;
    cursor: pointer;
}

.message_form button:hover {
    background: var(--couleur-secondaire);
}

/* INFOS ANNANCE */
.message_info h1,
.message_info_cle h1 {
    font-size: 18px;
    font-weight: 700;
    color: var(--couleur-principale);
}

.message_color_red {
    color: var(--couleur-secondaire) !important;
}

.message_info p {
    font-size: 16px;
    color: var(--couleur-dark);
    margin: 0;
}

/* BLOCS INTERNE */
.message_info>div {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* TITRES CLE */
.message_info_cle h5 {
    font-size: 16px;
    font-weight: 400;
    margin-top: 16px;
    color: var(--gris-principale);
}

/* --- Infos acheteur --- */
.message_buyer_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

.message_field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.message_field label {
    font-size: 13px;
    color: var(--couleur-dark);
    font-weight: 600;
}

.message_field input {
    width: 100%;
    padding: 10px 12px;
    font-size: 14px;
    border-radius: 10px;
    border: 1px solid var(--gris-secondaire);
    outline: none;
    background: var(--white-principale);
}

.message_field input:focus {
    border-color: var(--couleur-principale);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

@media (max-width: 768px) {
    .message_buyer_grid {
        grid-template-columns: 1fr;
    }
}

/* RESPONSIVE */
@media (max-width: 768px) {
    .message_container {
        flex-direction: column;
    }

    .message_form,
    .message_info {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/message/message.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA,kBAAkB;AAClB;;IAEI,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC;;;;mCAI+B;;AAEnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;IAEI,eAAe;IACf,0BAA0B;AAC9B;;AAEA,aAAa;AACb;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,aAAa;AACb;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA,WAAW;AACX;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA,kBAAkB;AAClB;;IAEI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,eAAe;AACf;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,uCAAuC;IACvC,6CAA6C;AACjD;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":["/* LAYOUT DES 2 CADRES */\n.message_container {\n    display: flex;\n    gap: 32px;\n    align-items: flex-start;\n}\n\n/* CADRES BLANCS */\n.message_form,\n.message_info {\n    background: var(--white-principale);\n    border-radius: 16px;\n    padding: 24px;\n    border: solid 1px var(--gris-secondaire);\n    box-shadow:\n        0 0 5px rgba(0, 0, 0, 0.05),\n        0 0 10px rgba(0, 0, 0, 0.05),\n        0 0 15px rgba(0, 0, 0, 0.08),\n        0 0 20px rgba(0, 0, 0, 0.1);\n\n}\n\n.message_image_status {\n    width: 20px;\n    height: 20px;\n    border: solid 2px var(--white-principale);\n    border-radius: 50%;\n    background-color: green;\n    position: absolute;\n    bottom: 10px;\n    right: 5px;\n}\n\n.message_nom {\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--couleur-dark);\n}\n\n.message_status,\n.message_tel {\n    font-size: 13px;\n    color: var(--couleur-dark);\n}\n\n/* LARGEURS */\n.message_form {\n    flex: 2;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.message_info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n/* HEADER MESSAGE */\n.message_header {\n    display: flex;\n    justify-content: space-between;\n}\n\n.message_header_vendeur {\n    display: flex;\n}\n\n.message_info_vendeur {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.message_image_vendeur {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-right: 16px;\n}\n\n.message_logo_whatshapp {\n    width: 30px;\n    height: 30px;\n}\n\n/* BODY MESSAGE */\n.message_body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.message_body h1 {\n    font-size: 18px;\n    font-weight: 500;\n    color: var(--couleur-dark);\n}\n\n.message_body h3 {\n    font-size: 16px;\n    font-weight: 400;\n    color: var(--couleur-dark);\n}\n\n/* TEXTAREA */\n.message_body textarea {\n    width: 100%;\n    min-height: 140px;\n    resize: vertical;\n    padding: 12px;\n    font-size: 14px;\n    border-radius: 8px;\n    border: 1px solid var(--gris-secondaire);\n}\n\n/* BOUTON */\n.message_form button {\n    align-self: flex-start;\n    width: 100%;\n    padding: 10px 24px;\n    border-radius: 10px;\n    border: none;\n    font-size: 16px;\n    background: var(--couleur-principale);\n    color: var(--white-principale);\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.message_form button:hover {\n    background: var(--couleur-secondaire);\n}\n\n/* INFOS ANNANCE */\n.message_info h1,\n.message_info_cle h1 {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--couleur-principale);\n}\n\n.message_color_red {\n    color: var(--couleur-secondaire) !important;\n}\n\n.message_info p {\n    font-size: 16px;\n    color: var(--couleur-dark);\n    margin: 0;\n}\n\n/* BLOCS INTERNE */\n.message_info>div {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n/* TITRES CLE */\n.message_info_cle h5 {\n    font-size: 16px;\n    font-weight: 400;\n    margin-top: 16px;\n    color: var(--gris-principale);\n}\n\n/* --- Infos acheteur --- */\n.message_buyer_grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px;\n}\n\n.message_field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.message_field label {\n    font-size: 13px;\n    color: var(--couleur-dark);\n    font-weight: 600;\n}\n\n.message_field input {\n    width: 100%;\n    padding: 10px 12px;\n    font-size: 14px;\n    border-radius: 10px;\n    border: 1px solid var(--gris-secondaire);\n    outline: none;\n    background: var(--white-principale);\n}\n\n.message_field input:focus {\n    border-color: var(--couleur-principale);\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n@media (max-width: 768px) {\n    .message_buyer_grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* RESPONSIVE */\n@media (max-width: 768px) {\n    .message_container {\n        flex-direction: column;\n    }\n\n    .message_form,\n    .message_info {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
